import React from 'react';
import _ from 'lodash';

import {
  BaseWidget,
  selectFields
} from 'modules';

import { Table } from 'iron-forge-react-modules';

import * as dataService from './dataService';
import * as types from './types';



const { FC: UserStatusSelectField } = selectFields.UserStatusSelectField.genComponentAndControllerGenerator();
const TableComponent = Table.genTableComponent<types.IColumnId>();



export const FC: React.FC = () => {
  const queryTuple = dataService.useQuery();
  const [saveUser, saveUserTuple] = dataService.useSaveUser();

  const rows = React.useMemo(
    (): types.IRow[] => _.map(queryTuple.data.users, (user): types.IRow => ({
      id: user.id,
      columnId2Value: {
        email: {
          type: 'string',
          label: user.email
        },
        fullName: {
          type: 'string',
          label: user.fullName
        },
        status: {
          type: 'component',
          sortableValue: user.status.displayName,
          label: (
            <UserStatusSelectField
              disableDefaultMargins
              label="Status"
              isDisabled={saveUserTuple.loading}
              selectProps={{
                value: {
                  id: user.status.id,
                  displayName: user.status.displayName
                },
                type: 'singleSelect',
                onChange: async value => {
                  if (value) {
                    saveUser(user.id, value.id);
                  }
                }
              }} />
          )
        }
      }
    })),
    [
      queryTuple.data.users,
      saveUser,
      saveUserTuple.loading
    ]
  );



  return (
    <BaseWidget.FC
      title="Users">
      <TableComponent
        rows={rows}
        initSortOptions={{
          columnId: 'email',
          direction: 'ascending'
        }}
        columns={[
          {
            id: 'email',
            label: "Email"
          },
          {
            id: 'fullName',
            label: "Full Name"
          },
          {
            id: 'status',
            label: "User Status"
          }
        ]} />
    </BaseWidget.FC>
  );
};
